<template>
  <div class="page-header-wrapper">
    <div class="page-header translucent-wrapper" v-bind:style="headerStyle">
      <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>

      <div class="advantage-addition">
        <img src="/static/img/icons/delete.svg" class="delete-icon" 
          @click="deleteBondedLoanAdvantage(advantage.id)"
        />

        <div class="centered">
          <span class="button-wrapper" @click="handleLoadPhoto">
            <a class="button is-info">+</a>Загрузить превью
          </span>
        </div>

        <b-field>
          <b-input placeholder="Заголовок" v-model="advantage.title" 
            @change="updateBondedLoanAdvantage(advantage)"
          ></b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Текст" type="textarea" 
            v-model="advantage.description" @change="updateBondedLoanAdvantage(advantage)"
          ></b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Ссылка на видео" v-model="advantage.videoLink" 
            @change="updateBondedLoanAdvantage(advantage)"
          ></b-input>
        </b-field>

        <b-field class="learn-more-field space-evenly">
          <b-input placeholder="Заголовок кнопки" v-model="advantage.buttonTitle" required />
          <b-input placeholder="Ссылка" v-model="advantage.buttonLink" required />
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Advantage',

    data () {
      return {
        base64photo: ''
      }
    },

    props: {
      advantage: {
        type: Object,
        required: true
      }
    },

    computed: {
      headerStyle () {
        if (this.advantage.videoPreview || this.base64photo) {
          if (!this.base64photo.length) {
            return { background: `url(/upload/photos/${this.advantage.videoPreview})` }
          } else {
            return {background: `url(${this.base64photo})`}
          }
        } else {
          return {background: ''}
        }
      }
    },

    methods: {
      ...mapActions(['deleteBondedLoanAdvantage', 'updateBondedLoanAdvantage']),

      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (ee) => {
          this.base64photo = ee.target.result
          this.$forceUpdate()
        }
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        this.advantage.newPhoto = formData
        this.updateBondedLoanAdvantage(this.advantage)
      },

      handleLoadPhoto () {
        this.$refs.loadPhotoButton.click()
      }
    }
  }
</script>

<style>
.advantage-addition-wrapper {
  background: #eeeeee;
  padding: 30px;
  margin: 20px 0px;
}

.advantage-addition, .service-description {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
}

.delete-icon {
  width: 24px;
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 100;
  cursor: pointer;
}

.space-evenly {
  justify-content: space-evenly;
}

.page-header {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// Advantage.vue?703a48ea